// Shared across page reloads and tabs; reset only at an authentication boundary.
const KEY = "visiontrakNewsSeenThisLogin";
const persistent = item => item && ["Always", "DateRange"].includes(item.displayMode);
const identity = item => `${item.id}:${item.version}`;
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch (_) { return []; }
};
export const resetNewsLoginSession = () => localStorage.removeItem(KEY);
export const wasNewsShownThisLogin = item => persistent(item) && read().includes(identity(item));
export const markNewsShownThisLogin = item => {
  if (!persistent(item)) return;
  const seen = read();
  if (!seen.includes(identity(item))) localStorage.setItem(KEY, JSON.stringify([...seen, identity(item)]));
};
